import React from "react";
import PropTypes from "prop-types";
import Modal from "shared/components/Modal";

import "./IconModal.scss";

const IconModal = ({
	onClose,
	show,
	image,
	headerText,
	bodyText,
	footerChildren,
}) => (
	<Modal
		className="iconModal"
		onCancel={onClose}
		show={show}
		willCloseOnClick
	>
		<div className="iconModal-icon">
			{image}
		</div>
		<div className="iconModal-title">
			{headerText}
		</div>
		<p className="iconModal-body">
			{bodyText}
		</p>
		<div className="iconModal-footer">
			{footerChildren}
		</div>
	</Modal>
);

IconModal.propTypes = {
	show: PropTypes.bool.isRequired,
	onClose: PropTypes.func.isRequired,
	headerText: PropTypes.node.isRequired,
	bodyText: PropTypes.string.isRequired,
	footerChildren: PropTypes.node.isRequired,
	image: PropTypes.node.isRequired,
};

export default IconModal;



// WEBPACK FOOTER //
// ./src/shared/components/IconModal/IconModal.jsx